import React, {Component, useState} from 'react'
import {questionActions} from "../../store/actions";
import {connect} from "react-redux";
import history from "../../route/history";

const QuestionWriteTerms = props => {

    const agreeChange = (e) => {
        const {value} = e.target
        value === 'Y' && history.push('/questionwrite');
        props.showTerms(false);
    }

    return (
        <React.Fragment>
            <div className="modal-terms-background"></div>
            <div className="modal-terms">
                <div>
                    <div className="modal-terms-header"><h4>개인정보취급방침 동의</h4></div>
                    <div className="modal-terms-description-box">
                        <h4>개인정보 수집 및 이용 동의</h4>
                        <div className="modal-terms-description">
                            ㈜한국무역정보통신(이하 ‘회사’라 함)은 수집한 개인정보를 다음의 목적으로 보유하고 활용합니다.<br />
                            <br />
                            1. 수집하는 개인정보의 항목<br />
                            o 전자무역 촉진에 관한 법률 제6조, 제12조, 시행령 제2조에 근거한 수집항목<br />
                            - 필수항목: 사업자등록번호, 상호, 대표자명, 주소, 아이디, 성명, 전화번호, 휴대폰번호, 이메일<br />
                            - 선택항목: 부서, 직위, 팩스번호, 통관고유부호, 신고인부호, 자동이체은행, 계좌번호, 예금주명, 생년월일<br />
                            - 자동수집: 이용자의 브라우저 종류 및 OS, 검색어, IP Address, 쿠키<br />
                            o 정보통신망 이용촉진 및 정보보호 등에 관한 법률근거한 수집항목<br />
                            -방문일시, 서비스이용기록<br />
                            <br />
                            2. 개인정보의 수집·이용 목적<br />
                            o 회원관리<br />
                            - 회원제 서비스 이용에 따른 본인확인, 개인식별, 불량회원의 부정 이용방지와 비인가 사용방지, 가입의사 확인, 분쟁조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달<br />
                            o 서비스 제공에 관한 계약이행 및 서비스 제공에 따른 요금정산 특정 맞춤서비스 제공, 청구서 등 발송, 본인인증, 요금결제 및 요금추심<br />
                            <br />
                            3. 개인정보의 보유 및 이용 기간<br />
                            o 회사는 회원 가입일로부터 서비스를 제공하는 기간 동안에 한하여 개인정보를 보유 및 이용하게 됩니다.<br />
                            o 회사는 회원탈퇴를 요청하거나 개인정보 수집 및 이용목적이 달성 또는 보유/이용기간이 종료된 후에는 해당 정보를 지체 없이 파기합니다.<br />
                            o 로그인 이력이 없는 등 1년의 기간 동안(또는 회원이 별도 요청한 기간 동안) 서비스를 이용하지 아니한 회원은 관련법령에 의거하여 휴면 회원으로 전환됩니다. 회사는 휴면 회원의 개인정보를 별도 DB에 암호화하여 분리보관하고, 회원의 요구가 있을 경우(로그인 시 포함) 휴면 계정을 사용가능 계정으로 복원합니다.<br />
                            o 다만, 상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우, 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.<br />
                            - 상업장부와 영업에 관한 중요서류 및 전표 : 10년–중요서류, 5년-전표(상법)<br />
                            - 계약 또는 청약철회 등에 관한 기록: 5년(전자상거래 등에서의 소비자보호에 관한 법률)<br />
                            - 대금결제 및 재화 등의 공급에 관한 기록: 5년(전자상거래 등에서의 소비자보호에 관한 법률)<br />
                            - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년(전자상거래 등에서의 소비자보호에 관한 법률)<br />
                            - 본인확인에 관한 기록 : 6개월(정보통신 이용촉진 및 정보보호 등에 관한 법률)<br />
                            - 방문에 관한 기록 : 3개월(통신비밀보호법)<br />
                            - 통신사실확인자료 제공시 필요한 로그기록 : 3개월(통신비밀보호법)
                        </div>
                    </div>
                    <div >
                        <div className="modal-terms-check-box">
                            <input type="radio"
                                   id="terms-check-agree"
                                   className="radio"
                                   name="agreeYn"
                                   value={'Y'}
                                   onChange={agreeChange}
                            />
                            <label htmlFor="terms-check-agree">동의함</label>
                            <input type="radio"
                                   id="terms-check-disagree"
                                   className="radio"
                                   name="agreeYn"
                                   value={'N'}
                                   onChange={agreeChange}
                            />
                            <label htmlFor="terms-check-disagree">동의안함</label>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
    }
}
const actionCreators = {
    showTerms: questionActions.showTerms,
}



export default connect(
    mapStateToProps,
    actionCreators
)(QuestionWriteTerms)